import { cookieHelper, CookieKeyEnum } from '@/app/cookies';
import type { AuthSchema } from '../types/authSchema';

export const initialState: AuthSchema = {
    loading: false,
    isInited: false,
    // True если пользователь не логинился с этого браузера или вышел вручную.
    skipRefresh: !cookieHelper.get(CookieKeyEnum.USER_DATA)?.refreshToken,
    isLoggedIn: false,
    userInfo: {},
    userInfoLoading: true,
};
